var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 12H19","stroke":"currentColor","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Minus.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
